import { render, staticRenderFns } from "./ProvenanceTable.vue?vue&type=template&id=7e5f8486&scoped=true&"
import script from "./ProvenanceTable.vue?vue&type=script&lang=js&"
export * from "./ProvenanceTable.vue?vue&type=script&lang=js&"
import style0 from "./ProvenanceTable.vue?vue&type=style&index=0&id=7e5f8486&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5f8486",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e5f8486')) {
      api.createRecord('7e5f8486', component.options)
    } else {
      api.reload('7e5f8486', component.options)
    }
    module.hot.accept("./ProvenanceTable.vue?vue&type=template&id=7e5f8486&scoped=true&", function () {
      api.rerender('7e5f8486', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/bottomLineProvenance/ProvenanceTable.vue"
export default component.exports